import { useQuery, gql } from "@apollo/client";

import { TEMPLATE_FRAGMENT } from "./useGetTemplate";

export const MAD_REPORT_FRAGMENT = gql`
  fragment MadReportFragment on Report {
    id
    type
    createdAt
    checkedAt
    filledAt
  }
`;

export const MAD_FRAGMENT = gql`
  fragment MadFragment on Mad {
    id
    createdAt
    startDate
    endDate
    madFunction
    title
    missionDescription
    template {
      ...TemplateFragment
    }
    documents {
      id
      url
      filename
    }
    talent {
      id
      email
      title
      name
      function
      email
      avatar
      canShow
    }
    referents {
      id
      email
      title
      name
      email
      function
      avatar
      canShow
    }
    campaign {
      id
      slug
      name
      canShow
    }
    contracts {
      id
      document
      contractTemplate {
        id
        title
      }
    }
    lastCheckedReport {
      ...MadReportFragment
    }
    reports {
      ...MadReportFragment
    }
  }
  ${MAD_REPORT_FRAGMENT}
  ${TEMPLATE_FRAGMENT}
`;

export const GET_MAD = gql`
  query getMad($id: ID!) {
    mad(id: $id) {
      ...MadFragment
    }
  }
  ${MAD_FRAGMENT}
`;

export default (options) => {
  return useQuery(GET_MAD, options);
};
